import GameStepBase from './game_step_base';


export default class WaitForHybridGameStep extends GameStepBase {
    static CLASS = 'WaitForHybridGameStep';

    _startTime = 0;
    _folderStruct = 0;
    _sharedFolder = '';

    init(params) {
        super.init(params);
        this._folderStruct = params.folderStruct;
        this._sharedFolder = params.sharedFolder;
    }

    run(gameOptions) {
        return this.serviceFactory.hybridService().executeWaitForHybridGameStep({
            folderStruct: this._folderStruct,
            sharedFolder: this._sharedFolder,
            gameType: gameOptions.gameType,
            vendorName: gameOptions.gameInfo?.vendorName,
            companyName: gameOptions.gameInfo?.companyName
        }).then(() => gameOptions);
    }
}